@if (!showPreview()) {
  <div class="columns">
    <div class="column darkmode-ignore">
      @if (originalPdfUrl()) {
        <app-pdf-viewer viewerId="JobPdfViewer" [pdfUrl]="originalPdfUrl()"></app-pdf-viewer>
      }
    </div>
    <div class="column">
      <div class="flex is-justify-content-flex-end">
        <label class="p-1 has-text-weight-bold" translate="siblings.notRelevant"></label>
        <label class="p-1 has-text-weight-bold" translate="siblings.relevant"></label>
        <label class="p-1 has-text-weight-bold" translate="siblings.duplicate"></label>
      </div>
      <div cdkDropList class="siblings-list" (cdkDropListDropped)="drop($event)">
        @for (sibling of siblings(); track sibling) {
          <div
            class="siblings-box flex"
            [class.has-background-grey]="sibling.isOriginal"
            [class.has-background-grey-lighter]="sibling.id == selectedJobId()"
            (click)="selectJob(sibling)"
            cdkDrag
          >
            <div class="flex p-4">
              <div class="siblings-info-container">
                <div class="flex">
                  <b
                    [translate]="
                      sibling.isOriginal ? 'siblings.originalDocument' : 'siblings.furtherDocument'
                    "
                  ></b>
                  @if (sibling.status === 'locked') {
                    <fino-icon icon="Lock 6" class="has-text-danger ml-4"></fino-icon>
                  }
                  @if (sibling.status === 'open') {
                    <fino-icon icon="Email Action Read" class="has-text-primary ml-4"></fino-icon>
                  }
                  @if (sibling.statusChangedBy) {
                    <small class="pt-1 pl-2"> {{ sibling.statusChangedBy }}</small>
                  }
                </div>
                @if (sibling.envelope.documentType) {
                  <p class="has-text-weight-bold has-text-orange">
                    {{ 'documentType.' + sibling.envelope.documentType | translate }}
                  </p>
                }
                @if (sibling.envelope.rejectionReason) {
                  <p
                    class="has-text-weight-bold"
                    [class.has-text-danger]="sibling.envelope.rejectionReason !== 'OK'"
                    [class.has-text-success]="sibling.envelope.rejectionReason === 'OK'"
                  >
                    {{ sibling.envelope.rejectionReason | translate }}
                  </p>
                }
                <p>
                  {{ sibling.envelope.received | date: 'dd.MM.yyyy hh:mm:ss' }}
                </p>
                <p>{{ sibling.envelope.sender }}</p>
                <p class="is-flex" (click)="copyDocumentId(sibling.id, $event)">
                  ID: {{ sibling.id }}
                  <fino-icon
                    icon="Copy Paste 1"
                    class="has-text-primary click-pop ml-3"
                  ></fino-icon>
                </p>
              </div>
              <div class="siblings-state-container">
                <div class="control flex is-justify-content-space-between">
                  <input
                    type="radio"
                    [(ngModel)]="sibling.mergeSiblingState"
                    [name]="sibling.id"
                    [value]="SIBLINGS_TYPES.DOCUMENT_TYPE_NOT_RELEVANT"
                  />
                  <input
                    type="radio"
                    [(ngModel)]="sibling.mergeSiblingState"
                    [name]="sibling.id"
                    [value]="SIBLINGS_TYPES.DOCUMENT_TYPE_RELEVANT"
                    checked
                  />
                  <input
                    type="radio"
                    [(ngModel)]="sibling.mergeSiblingState"
                    [name]="sibling.id"
                    [value]="SIBLINGS_TYPES.DOCUMENT_TYPE_DUPLICAT"
                    checked
                  />
                </div>
                <div class="additional-info-container">
                  @if (sibling.envelope.newIban) {
                    <small
                      translate="siblings.newIban"
                      [translateParams]="{ iban: sibling.envelope.newIban | iban }"
                    ></small>
                  }
                  ><br />
                  @if (sibling.envelope.oldIban) {
                    <small
                      translate="siblings.oldIban"
                      [translateParams]="{ iban: sibling.envelope.oldIban | iban }"
                    >
                    </small>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="column darkmode-ignore">
      @if (siblingPdfUrl()) {
        <app-pdf-viewer viewerId="SiblingPdfViewer" [pdfUrl]="siblingPdfUrl()"></app-pdf-viewer>
      }

      <div class="is-flex">
        <button
          [primary]="true"
          [loading]="!mergeSubscription.closed"
          (click)="createPreview()"
          class="mr-1"
          fino-button
          translate="siblings.preview"
        ></button>
        <button
          type="button"
          class="ml-1"
          (click)="abortMerge()"
          translate="siblings.abort"
          fino-button
        ></button>
      </div>
    </div>
  </div>
}
@if (showPreview()) {
  <div class="columns">
    <div class="column darkmode-ignore">
      @if (previewUrl()) {
        <ng2-pdfjs-viewer
          [showSpinner]="false"
          viewerId="PreviewPdfViewer"
          [pdfSrc]="previewUrl()"
        ></ng2-pdfjs-viewer>
      }
    </div>
    <form [formGroup]="mergeSiblingForm" class="column">
      @for (sibling of siblings(); track sibling) {
        <div>
          @if (sibling.mergeSiblingState !== SIBLINGS_TYPES.DOCUMENT_TYPE_NOT_RELEVANT) {
            <article class="panel is-primary" [class.has-background-primary]="sibling.isOriginal">
              <div class="panel-block flex is-flex-direction-column">
                @if (sibling.isOriginal) {
                  <b translate="siblings.originalDocument"></b>
                }
                @if (!sibling.isOriginal) {
                  <b translate="siblings.furtherDocument"></b>
                }
                <p>{{ sibling.envelope.received | date: 'dd.MM.yyyy hh:mm:ss' }}</p>
                <p>{{ sibling.id }}</p>
              </div>
            </article>
          }
        </div>
      }

      <fino-checkbox
        class="mt-2"
        formControlName="documentsChecked"
        label="siblings.documentComplete"
      >
      </fino-checkbox>

      <div class="is-flex">
        <button
          [primary]="true"
          [disabled]="!mergeButtonActive()"
          class="mr-1"
          [loading]="!mergeSubscription.closed"
          (click)="mergeDocuments()"
          fino-button
          translate="siblings.mergeDocuments"
        ></button>
        <button
          type="button"
          (click)="abortPreview()"
          class="ml-1"
          fino-button
          translate="siblings.abort"
        ></button>
      </div>
    </form>
  </div>
}
